import classNames from 'classnames/bind';
import styles from '@/styles/superstack/companies/CardBannerOnBlur.module.scss';
const cx = classNames.bind(styles);

import LinkTag from '@/src/component/LinkTag';
import { Button } from '@/src/component/superstack/base/Button';

const CardBannerOnBlur = ({ text1, text2, btnName, btnUrl, isSummary = false, ...props }) => {
  return (
    <div className={cx(['banner-on-blur', isSummary ? 'is-summary' : ''])} {...props}>
      <div className={cx('content')}>
        <p className={cx('text')}>
          {text1}
          <br />
          {text2}
        </p>
        <LinkTag isNextPage={true} href={btnUrl}>
          <Button mode={'filled'} size={isSummary ? 'sm' : 'lg'}>
            {btnName}
          </Button>
        </LinkTag>
      </div>
    </div>
  );
};

export { CardBannerOnBlur };
